<template>
  <lazy-div :load="doInit">
  <page>
    <div>
      <v-card>
        <v-card-text>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs11 sm11 md11 lg11>
                <form ref="CSVForm">
                  <input type="file" style="display: none" ref="CSVfile" accept=".csv" @change="doValidateFile" />
                </form>
                <v-text-field
                  readonly
                  v-model="form.requestedFile"
                  :label="labels.requestedFile"
                  :error-messages="errors.collect('requestedFile')"
                  data-vv-name="requestedFile"
                  :data-vv-as="labels.requestedFile"
                  append-icon="mdi-magnify"
                  @click:append="pickFile"
                  v-validate="'required'"
                ></v-text-field>
              </v-flex>
              <v-flex xs1 sm1 md1 lg1>
                <v-btn flat icon color="primary" title="Load Report History" @click="viewRptHistory" style="margin-top: 15px;">
                  <v-icon>mdi-archive</v-icon>
                  <rpt-jobs-history title="Report History" id="UploadPostalCode" v-model="rptHistory" @close="doClose"></rpt-jobs-history>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
          <v-container fluid grid-list-lg>
            <v-btn color="primary" dark class=" mr-2" @click="doSend">
              Upload
              <v-icon>mdi-content-save</v-icon>
            </v-btn>
          </v-container>
        </v-card-text>
      </v-card>
    </div>

    <v-dialog v-model="processing" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text class="pa-3">
          Processing...
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showErrorDialog" width="800px">
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon>mdi-information</v-icon>
          <v-toolbar-title>System Information</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <div v-if="messages.length > 0" class="pb-3">
            <v-subheader>Oops something went wrong:</v-subheader>
            <ul class="showErrorMsgs">
              <li v-for="(error, index) in messages" :key="index">
                {{ error.message }}
              </li>
            </ul>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click.native="showErrorDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </page>
</lazy-div>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { extractMenu } from '@/utils/extract'
import RptJobsHistory from '@/components/reports/shared/RptJobsHistory'

export default {
  data() {
    return {
      processing: false,
      showErrorDialog: false,
      rptHistory: false,
      labels: {
        requestedFile: 'Postal Code'
      },
      form: {
        requestedFile: ''
      }
    }
  },
  computed: {
    displayErrorDialog() {
      return this.messages
    }
  },
  watch: {
    displayErrorDialog: {
      handler: function (messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    }
  },
  methods: {
    async doInit() {
      this.$store.dispatch('reportsInit')
      console.log(this.$store.state.reports)
      const apiURI = this.$store.state.app.menu.cacheControl
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          const { data } = result
          if (data) {
            this.menu = extractMenu(data._links)
          }
        } catch (err) {
          throw err
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    viewRptHistory() {
      this.rptHistory = true
    },
    doValidateFile(e) {
      this.form.requestedFile = ''
      this.resetMessages()
      if (e.target.files[0]) {
        const file = e.target.files[0]
        if (file.name.indexOf('.csv') !== -1) {
          this.form.requestedFile = file.name
          const fileReader = new FileReader()
          fileReader.readAsText(file)
        } else {
          this.$toast.error('Please Select XML File (.csv) Only!')
        }
      }
      this.doUpload(e)
    },
    async doUpload(event) {
      await this.getFile(event)
    },
    async getFile(event) {
      this.file = event.target.files[0]
    },
    pickFile() {
      this.$refs.CSVForm.reset()
      this.$refs.CSVfile.click()
    },
    async doSend() {
      const apiUrl = this.$store.state.parameters.menu.sgAddressUpload
      if (apiUrl) {
        try {
          this.processing = true
          let formData = new FormData()
          formData.append('file', this.file)
          const result = await this.$http.post(apiUrl, formData)
          if (result.data) {
            this.processing = false
            this.$toast.success(result.data.messages[0].message)
            this.form.requestedFile = ''
          }
          // this.processing = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.processing = false
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url. [uploadPostalCodeList]')
      }
    },
    doClose(rptKeys) {
      this.rptHistory = false
    }
  },
  components: {
    RptJobsHistory
  },
  mixins: [
    MessageMixin
  ]
}
</script>

<style lang="scss">

</style>
